export default __webpack_public_path__ + "static/media/bitmap@2x.060602cc.png";